import { ThemeOptions } from '@mui/material';

export const One: ThemeOptions = {
    palette: {
        mode: 'dark',
        success: {
            main: '#46bf00',
            light: '#6dd92e',
            dark: '#337c09'
        },
        error: {
            light: '#7fff75',
            main: '#39de3d',
            dark: '#1c8b20',
        },
        secondary: {
            main: '#6a6b70',
            dark: '#191c22'
        },
        background: {
            paper: '#21242a',
            default: '#30343c',
        }
    },
    typography: {
        fontFamily: '"Assistant", sans-serif',
        fontSize: 14,
    },
    shape: {
        borderRadius: 4
    }
};

export const Two: ThemeOptions = {
    palette: {
        mode: 'dark',
        primary: {
            main: '#286EF6',
            light: '#ffffff' //customColor
        },
        secondary: {
            main: '#313cad',
            light: '#282828', //inputColor
            dark: '#000000' //imgColor
        },
        info: {
            main: '#0288d1',
            light: '#282828', //inputBorder
            dark: '#ffffff94' //effectColor
        },
        error: {
            main: '#ff0052'
        },
        success: {
            main: '#2e7d32',
            light: '#282828',
            dark: '#ffffff' //originColor
        },
        background: {
            paper: '#171717',
            default: '#121212'
        }
    },
    typography: {
        fontFamily: 'Arimo,sans-serif !important',
        fontSize: 14
    },
    shape: {
        borderRadius: 4
    }
};
